(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nail-grinder-product-story"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ngs-video-media').forEach(function (media) {
  var video = media.querySelector('video');
  var button = media.querySelector('.ngs-video-play');
  if (!video || !button) return;
  button.addEventListener('click', function () {
    video.play();
  });
  video.addEventListener('play', function () {
    media.classList.add('is-playing');
  });
  video.addEventListener('pause', function () {
    media.classList.remove('is-playing');
  });
});

  } catch(e) { console.error(e); }
})();
})();
